// src/services/blockService.ts

import { API_BASE_URL } from "../constants";

const authHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface BlockedUserItem {
  userId: number;
  username: string;
  role: string;
  blockedAt: string;
}

export interface BlockedListResponse {
  content: BlockedUserItem[];
  currentPage: number;
  totalItems: number;
  totalPages: number;
}

/**
 * Block a user by their ID.
 * POST /api/block/{targetUserId}
 */
export const blockUser = async (targetUserId: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/block/${targetUserId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "BLOCK_FAILED");
  }
};

/**
 * Unblock a user by their ID.
 * DELETE /api/block/{targetUserId}
 */
export const unblockUser = async (targetUserId: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/block/${targetUserId}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeaders() },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "UNBLOCK_FAILED");
  }
};

/**
 * Get the caller's paginated blocked-user list.
 * GET /api/block/list?page=0&size=20
 */
export const fetchBlockedList = async (
  page = 0,
  size = 20
): Promise<BlockedListResponse> => {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  const response = await fetch(`${API_BASE_URL}/api/block/list?${params}`, {
    headers: { "Content-Type": "application/json", ...authHeaders() },
  });
  if (!response.ok) {
    throw new Error("FETCH_BLOCKED_LIST_FAILED");
  }
  return response.json();
};